import { useTranslation } from 'react-i18next';
import { OfferForm } from '../../components/offer-form/offer-form';
import { PageHeader } from '@/components/core';

export const OfferBuilderPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader title={t('ADD_CONDITIONAL_OFFER')} />
      <OfferForm />
    </div>
  );
};
